import * as amplitude from '@amplitude/analytics-browser';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AppContent } from 'init/AppContent';
import { ErrorBoundary } from 'init/ErrorBoundary';
import 'libs/styles/global.css';
import 'libs/styles/toastify.css';
import { fixFirefoxDrag } from 'libs/utils/other/firefoxFix';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useEffect, useReducer } from 'react';
import ReactGA from 'react-ga4';
import { ToastContainer } from 'react-toastify';
import { GraphQLProvider } from 'session/GraphQLProvider';
import { AppStateProvider } from 'session/ctxApp';
import { DebugStateProvider } from 'session/ctxDebug';
import { DetailStateProvider } from 'session/ctxDetail';
import { EditStateProvider } from 'session/ctxEdit';
import { ModalStateProvider } from 'session/ctxModal';
import { ViewStateProvider } from 'session/ctxView';
import { GlobalContext } from 'session/state/context';
import { useStateReducer } from 'session/state/reducer';
import { globalState } from 'session/state/state';
import Config, { currentVersion } from 'static/config/coreConfig';

if (Config.GoogleAnalyticsCode) {
    ReactGA.initialize(Config.GoogleAnalyticsCode);
}

amplitude.init(Config.AmplitudeApiKey);

export interface IProps {}

export const App = (): JSX.Element => {
    const stateReducer = useStateReducer();
    const [state, dispatch] = useReducer(stateReducer, globalState);

    useEffect(() => {
        fixFirefoxDrag();
    }, []);

    useEffect(() => {
        console.log('%c Version ', 'background-color: cyan; color: black', currentVersion);
    }, []);

    // useEffect(() => {
    //     setWidth();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    return (
        <div id="mapheim">
            <GoogleOAuthProvider clientId={Config.GoogleClientId}>
                <ErrorBoundary>
                    <GlobalContext.Provider value={{ state, dispatch }}>
                        <GraphQLProvider>
                            <ViewStateProvider>
                                <EditStateProvider>
                                    <DetailStateProvider>
                                        <DebugStateProvider>
                                            <ModalStateProvider>
                                                <AppStateProvider>
                                                    <AppContent />
                                                </AppStateProvider>
                                            </ModalStateProvider>
                                        </DebugStateProvider>
                                    </DetailStateProvider>
                                </EditStateProvider>
                            </ViewStateProvider>
                        </GraphQLProvider>
                    </GlobalContext.Provider>
                </ErrorBoundary>
            </GoogleOAuthProvider>
            <ToastContainer />
        </div>
    );
};
